import { render, staticRenderFns } from "./verticalTopbar.vue?vue&type=template&id=537f8d42&"
import script from "./verticalTopbar.vue?vue&type=script&lang=js&"
export * from "./verticalTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports